var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 19.8c1.6-2.2 1.6-5.2 0-7.4-1.8-2.6-6-6.8-13.2-6.8S4.6 9.8 2.8 12.4c-1.6 2.2-1.6 5.2 0 7.4 1.8 2.6 6 6.8 13.2 6.8 7.2-.3 11.4-4.5 13.2-6.8m-3-2.3c-1.8 2.4-5 5.2-10.2 5.2S7.4 20 5.8 17.6c-.6-1-.6-2.2 0-3.2C7.4 12 10.6 9.2 16 9.2s8.6 2.8 10.2 5.2c.8 1 .8 2.2 0 3.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 3.8
  })));
};
export default SvgEyeOpen;